import React from 'react'
import { RouteConfig } from 'react-router-config'
import Blank from '@/layouts/Blank'
import orders from './orders'
import logistics from './logistics'
// import { DropOff } from '@/components/Icons'
import freight from './freight'
import { Redirect } from 'react-router'

const routes: RouteConfig[] = [
  {
    path: '/ship',
    component: Blank,
    menuTitle: 'menu.shipments',
    group: 'shipments',
    // icon: DropOff,
    routes: [
      ...freight,
      ...orders,
      ...logistics,
      {
        path: '/',
        component() {
          return <Redirect to="/ship/order/list"></Redirect>
        },
      },
    ],
  },
]

export default routes
